// mockData.js - Bilingual mock data for Gravante Solar

export const getProducts = (language) => [
  {
    id: 1,
    name: 'Aiko Module',
    category: language === 'en' ? 'Photovoltaics' : 'Photovoltaik',
    description: language === 'en' 
      ? 'High-efficiency solar modules of the latest generation with maximum energy yield'
      : 'Hocheffiziente Solarmodule der neuesten Generation mit maximaler Energieausbeute',
    image: 'https://customer-assets.emergentagent.com/job_4471c19e-bde9-4b97-9a10-805621e3566d/artifacts/sg9160pk_IMG_7643.jpeg',
    features: language === 'en'
      ? ['25 year warranty', 'Up to 22% efficiency', 'Snow load certified']
      : ['25 Jahre Garantie', 'Bis zu 22% Wirkungsgrad', 'Schneelast zertifiziert']
  },
  {
    id: 2,
    name: language === 'en' ? 'Bosch Heat Pump' : 'Bosch Wärmepumpe',
    category: language === 'en' ? 'Heat Pump' : 'Wärmepumpe',
    description: language === 'en'
      ? 'Energy-efficient heat pumps for sustainable heating and cooling'
      : 'Energieeffiziente Wärmepumpen für nachhaltiges Heizen und Kühlen',
    image: 'https://customer-assets.emergentagent.com/job_4471c19e-bde9-4b97-9a10-805621e3566d/artifacts/zsx6drp5_660d8c7d6accf5468614272d_hover_wp.webp',
    features: language === 'en'
      ? ['A+++ energy class', 'Whisper-quiet operation', 'Smart Home integration']
      : ['A+++ Energieklasse', 'Flüsterleiser Betrieb', 'Smart Home Integration']
  },
  {
    id: 3,
    name: 'SIG Energy System',
    category: language === 'en' ? 'Energy Storage' : 'Energiespeicher',
    description: language === 'en'
      ? 'Intelligent energy storage solutions for maximum independence'
      : 'Intelligente Energiespeicherlösungen für maximale Unabhängigkeit',
    image: 'https://customer-assets.emergentagent.com/job_4471c19e-bde9-4b97-9a10-805621e3566d/artifacts/9qoy3mgg_IMG_7644.jpeg',
    features: language === 'en'
      ? ['10 kWh storage capacity', 'Backup power function', '15 year warranty']
      : ['10 kWh Speicherkapazität', 'Notstromfunktion', '15 Jahre Garantie']
  },
  {
    id: 4,
    name: language === 'en' ? 'Vaillant Heating' : 'Vaillant Heizung',
    category: language === 'en' ? 'Heat Pump' : 'Wärmepumpe',
    description: language === 'en'
      ? 'Premium heat pump systems with German engineering'
      : 'Premium Wärmepumpensysteme mit deutscher Ingenieurskunst',
    image: 'https://customer-assets.emergentagent.com/job_4471c19e-bde9-4b97-9a10-805621e3566d/artifacts/8hvev9ag_IMG_7646.jpeg',
    features: language === 'en'
      ? ['Integrated cooling function', '5 year warranty', 'Low maintenance']
      : ['Kühlfunktion integriert', '5 Jahre Garantie', 'Wartungsarm']
  }
];

export const getBenefits = (language) => [
  {
    title: language === 'en' ? 'Cost Savings' : 'Kostenersparnis',
    description: language === 'en'
      ? 'Up to 70% reduction in energy costs through modern photovoltaics and heat pumps'
      : 'Bis zu 70% Reduzierung der Energiekosten durch moderne Photovoltaik und Wärmepumpen',
    icon: 'TrendingDown'
  },
  {
    title: language === 'en' ? 'Environmental Protection' : 'Umweltschutz',
    description: language === 'en'
      ? 'CO2-neutral energy from sun and ambient heat for a green future'
      : 'CO2-neutrale Energie aus Sonne und Umgebungswärme für eine grüne Zukunft',
    icon: 'Leaf'
  },
  {
    title: language === 'en' ? 'Independence' : 'Unabhängigkeit',
    description: language === 'en'
      ? 'Become independent from rising electricity prices and energy crises'
      : 'Machen Sie sich unabhängig von steigenden Strompreisen und Energiekrisen',
    icon: 'Zap'
  },
  {
    title: language === 'en' ? 'Value Increase' : 'Wertsteigerung',
    description: language === 'en'
      ? 'Increase the value of your property through sustainable energy technology'
      : 'Erhöhen Sie den Wert Ihrer Immobilie durch nachhaltige Energietechnik',
    icon: 'Home'
  }
];

export const getTestimonials = (language) => [
  {
    name: 'Familie Müller',
    location: language === 'en' ? 'Munich' : 'München',
    text: language === 'en'
      ? 'Since installing our Gravante Solar photovoltaic system, we save over €150 monthly. The consultation was first class!'
      : 'Seit der Installation unserer Photovoltaikanlage von Gravante Solar sparen wir monatlich über 150€. Die Beratung war erstklassig!',
    rating: 5
  },
  {
    name: 'Thomas Schmidt',
    location: 'Berlin',
    text: language === 'en'
      ? 'The Bosch heat pump runs perfectly. Professional installation and excellent service. Highly recommended!'
      : 'Die Bosch Wärmepumpe läuft perfekt. Professionelle Installation und hervorragender Service. Sehr empfehlenswert!',
    rating: 5
  },
  {
    name: 'Anna Weber',
    location: 'Hamburg',
    text: language === 'en'
      ? 'Complete solution with solar and heat pump. Finally independent from fossil fuels. Thank you Gravante Solar!'
      : 'Komplettlösung mit Solar und Wärmepumpe. Endlich unabhängig von fossilen Brennstoffen. Danke Gravante Solar!',
    rating: 5
  }
];

export const getFaqs = (language) => [
  {
    question: language === 'en'
      ? 'How long does it take to install a photovoltaic system?'
      : 'Wie lange dauert die Installation einer Photovoltaikanlage?',
    answer: language === 'en'
      ? 'Installing an average photovoltaic system usually takes 2-3 days. After installation, commissioning is carried out by our certified technicians.'
      : 'Die Installation einer durchschnittlichen Photovoltaikanlage dauert in der Regel 2-3 Tage. Nach der Montage erfolgt die Inbetriebnahme durch unsere zertifizierten Techniker.'
  },
  {
    question: language === 'en'
      ? 'What subsidies are available for heat pumps?'
      : 'Welche Förderungen gibt es für Wärmepumpen?',
    answer: language === 'en'
      ? 'There are attractive government subsidies of up to 40% of investment costs for heat pumps. We will be happy to advise you on all available funding programs.'
      : 'Für Wärmepumpen gibt es attraktive staatliche Förderungen von bis zu 40% der Investitionskosten. Wir beraten Sie gerne zu allen verfügbaren Förderprogrammen.'
  },
  {
    question: language === 'en'
      ? 'Is a photovoltaic system worthwhile even without storage?'
      : 'Lohnt sich eine Photovoltaikanlage auch ohne Speicher?',
    answer: language === 'en'
      ? 'Yes, a photovoltaic system is economical even without storage. However, with storage you can increase your self-consumption from 30% to up to 70%.'
      : 'Ja, auch ohne Speicher ist eine Photovoltaikanlage wirtschaftlich. Mit einem Speicher können Sie jedoch Ihren Eigenverbrauch von 30% auf bis zu 70% steigern.'
  },
  {
    question: language === 'en'
      ? 'How maintenance-intensive are heat pumps?'
      : 'Wie wartungsintensiv sind Wärmepumpen?',
    answer: language === 'en'
      ? 'Modern heat pumps require very little maintenance. An annual inspection by a specialist is recommended to ensure long-term efficiency.'
      : 'Moderne Wärmepumpen sind sehr wartungsarm. Eine jährliche Inspektion durch einen Fachmann ist empfehlenswert, um die Effizienz langfristig zu sichern.'
  },
  {
    question: language === 'en'
      ? 'What is the lifespan of solar modules?'
      : 'Was ist die Lebensdauer von Solarmodulen?',
    answer: language === 'en'
      ? 'High-quality solar modules have a lifespan of 25-30 years. Most manufacturers provide a 25-year performance guarantee of at least 80% of original output.'
      : 'Hochwertige Solarmodule haben eine Lebensdauer von 25-30 Jahren. Die meisten Hersteller geben eine Leistungsgarantie von 25 Jahren mit mindestens 80% der ursprünglichen Leistung.'
  }
];

export const getProcessSteps = (language) => [
  {
    step: 1,
    title: language === 'en' ? 'Consultation' : 'Beratung',
    description: language === 'en' 
      ? 'Free initial consultation and needs analysis'
      : 'Kostenlose Erstberatung und Analyse Ihres Energiebedarfs'
  },
  {
    step: 2,
    title: language === 'en' ? 'Planning' : 'Planung',
    description: language === 'en'
      ? 'Individual planning and customized offer'
      : 'Individuelle Planung und maßgeschneidertes Angebot'
  },
  {
    step: 3,
    title: language === 'en' ? 'Installation' : 'Installation',
    description: language === 'en'
      ? 'Professional installation by certified specialists'
      : 'Professionelle Montage durch zertifizierte Fachkräfte'
  },
  {
    step: 4,
    title: 'Service',
    description: language === 'en' 
      ? 'Long-term support and maintenance service'
      : 'Langfristiger Support und Wartungsservice'
  }
];

// Keep old exports for backwards compatibility (German only)
export const products = getProducts('de');
export const benefits = getBenefits('de');
export const testimonials = getTestimonials('de');
export const faqs = getFaqs('de');
export const processSteps = getProcessSteps('de');
